import styled from 'styled-components';

/* 
This is the same max-width as is used by Storeblocks/Pretzel for the Select 
component, therefor used here as well in order for the forms to look consistent.
*/
const PageWidth = styled.div`
  margin: 0 auto;
  max-width: 528px;
`;

export default PageWidth;
